import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCarrierConnectAvailableCarriers } from "./autogen/AutogenLayoutCarrierConnectAvailableCarriers";

export class CarrierConnectAvailableCarriers extends AutogenLayoutCarrierConnectAvailableCarriers {
    tableAvailableCarriersOnRowDisplay(event: TableRowDisplayEvent) {
        const labelWarning: Label = event.getTableRow().findComponentById("labelWarning") as Label;
        labelWarning.visible = (event.getTableRow().data["persisted"] != "Y");
        labelWarning.tooltip = `${event.getTableRow().data["scac"]} not found in Carrier table.`;
    }
}
